import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import LanguageContext from "../../i18n/LanguageContext";

class AboutV4 extends Component {
  render() {
    const { t } = this.context;
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__about-us-area pt-120--- pb-90 mt--30 go-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img
                  src={publicUrl + "assets/img/hak.png"}
                  alt="About Us Image"
                />
                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
                  <div className="ltn__video-img ltn__animation-pulse1"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    {t("aboutPage.subtitle")}
                  </h6>
                  <h1 className="section-title">
                    {t("aboutPage.title")}<span>.</span>
                  </h1>
                  <p>{t("aboutPage.text")}</p>
                </div>
                <ul className="ltn__list-item-half clearfix">
                  <li>
                    <i className="flaticon-home-2" />
                    {t("aboutPage.li1")}
                  </li>
                  <li>
                    <i className="flaticon-mountain" />
                    {t("aboutPage.li2")}
                  </li>
                  <li>
                    <i className="flaticon-heart" />
                    {t("aboutPage.li3")}
                  </li>
                  <li>
                    <i className="flaticon-secure" />
                    {t("aboutPage.li4")}
                  </li>
                </ul>
                <div className="ltn__callout bg-overlay-theme-05  mt-30">
                  <p>{t("aboutPage.callout")} </p>
                </div>
                <div className="btn-wrapper animated">
                  <a href="https://api.whatsapp.com/send?phone=905520721972" className="theme-btn-1 btn btn-effect-1">
                    {t("aboutPage.reserve")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AboutV4.contextType = LanguageContext;

export default AboutV4;
